import { Passenger } from 'app/shared/models/passenger.model';
import { Booking } from '../../shared/models/booking.model';
export class UpdateBookingOptions {
    public emitPassengers = true;
    constructor(public index: number, public booking: Booking, public savedPassengerGuid: string, emitPassengers?: boolean) { 
        if(emitPassengers !== undefined){
            this.emitPassengers = emitPassengers;
        }
    }
}
export class UpdatePassengerGuidsOptions {
    constructor(public passengers: Passenger[]) { }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/events.model.ts